<template>
    <div class="af-table-wrap">
        <Loading type="line" :center="false" v-show="loading" />
        <table v-show="!loading" class="af-table">
            <thead>
                <tr>
                    <th>Descrição</th>
                    <th></th>
                    <th></th>
                    <th></th>
                    <th class="th-actions"></th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(it, idx) in items">
                    <AuthorizationRow :item="it" />
                    <tr v-if="idx < items.length - 1" class="divider-row">
                        <td colspan="5"></td>
                    </tr>
                </template>
                <template v-if="items.length == 0">
                    <div class="af-empty">Nenhum registro encontrato!</div>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>

import AuthorizationRow from './AuthorizationRow.vue'
import Loading from "@nixweb/nixloc-ui/src/component/shared/Loading.vue";

import { mapActions, mapGetters } from "vuex";

export default {
    name: 'AuthorizationTable',
    components: { AuthorizationRow, Loading },
    data() {
        return {
            urlGetAll: "/api/v1/adm/authorization/get-all",
            items: [],
            loading: true,
        }
    },
    mounted() {
        this.getAll();
    },
    computed: {
        ...mapGetters("generic", ["event"]),
    },
    methods: {
        ...mapActions("generic", ["getApi"]),
        getAll() {
            let params = {
                url: this.urlGetAll,
            };
            this.getApi(params).then((response) => {
                this.items = response.content;
                this.loading = false;
            });
        },
    },
    watch: {
        event: {
            handler(event) {
                if (event.name == "getAllAuthorization") {
                    this.getAll();
                }
            },
            deep: true,
        },
    }
}
</script>

<style scoped>
.divider-row td {
    border-bottom: 1px solid #e6e7eb;
    padding: 0;
    height: 1px;
}

.af-table-wrap {
    border: 1px solid #e6e7eb;
    border-radius: 12px;
    overflow: hidden;
}

.af-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
}

.af-table thead th {
    background: #fafafa;
    text-align: left;
    padding: 8px 10px;
    border-bottom: 1px solid #e6e7eb;
    font-size: 13px;
    color: #757d8c;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px !important;
    text-transform: uppercase;
}

.th-actions {
    text-align: right;
    width: 180px;
}

.af-empty {
    padding: 14px;
}
</style>
